import { Link } from 'react-router-dom';

export default function FooterSection() {
  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (!el) return;
    const top = el.getBoundingClientRect().top + window.scrollY - 72;
    window.scrollTo({ top, behavior: 'smooth' });
  };

  return (
    <footer className="bg-slate-950 text-white py-14 sm:py-20 px-4 sm:px-6 pb-32 sm:pb-20">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 sm:gap-12 mb-10 sm:mb-14">
          {/* Marque */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2.5 mb-4">
              <div className="w-10 h-10 rounded-xl overflow-hidden flex-shrink-0">
                <img
                  src="https://static.readdy.ai/image/a17d3ae5e640a18a289681692364ae47/fc2ed0bd71fb688a40f03f8096cc646d.jpeg"
                  alt="UzunDigital"
                  className="w-full h-full object-cover"
                  loading="lazy"
                  width="40"
                  height="40"
                />
              </div>
              <span className="text-lg font-black">UzunDigital</span>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed mb-5">
              Votre site professionnel livré en 7 jours maximum, à partir de 69€/mois.
            </p>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></div>
              <span className="text-emerald-400 text-xs font-bold">Disponible maintenant</span>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-bold mb-4 text-sm text-white uppercase tracking-wider">Navigation</h4>
            <ul className="space-y-2.5 text-slate-400 text-sm">
              <li>
                <button onClick={() => scrollToSection('avantages')} className="hover:text-emerald-400 transition-colors cursor-pointer text-left">
                  Avantages
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('portfolio')} className="hover:text-emerald-400 transition-colors cursor-pointer text-left">
                  Réalisations
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('tarifs')} className="hover:text-emerald-400 transition-colors cursor-pointer text-left">
                  Tarifs
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('faq')} className="hover:text-emerald-400 transition-colors cursor-pointer text-left">
                  FAQ
                </button>
              </li>
              <li>
                <Link to="/offres" className="hover:text-emerald-400 transition-colors">
                  Nos Offres
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold mb-4 text-sm text-white uppercase tracking-wider">Services</h4>
            <ul className="space-y-2.5 text-slate-400 text-sm">
              <li className="flex items-center gap-2">
                <i className="ri-layout-line text-emerald-500 text-sm flex-shrink-0"></i>
                <span>Site Vitrine</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-store-2-line text-emerald-500 text-sm flex-shrink-0"></i>
                <span>Site E-commerce</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-calendar-check-line text-emerald-500 text-sm flex-shrink-0"></i>
                <span>Site avec RDV</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-shield-check-line text-emerald-500 text-sm flex-shrink-0"></i>
                <span>Maintenance</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-search-line text-emerald-500 text-sm flex-shrink-0"></i>
                <span>SEO & Référencement</span>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold mb-4 text-sm text-white uppercase tracking-wider">Contact</h4>
            <div className="space-y-3 text-sm">
              <a
                href="mailto:uzundigital71@gmail.com"
                className="flex items-start gap-2.5 text-slate-400 hover:text-emerald-400 transition-colors group"
                rel="nofollow"
              >
                <i className="ri-mail-line text-emerald-500 text-base flex-shrink-0 mt-0.5"></i>
                <span className="break-all">uzundigital71@gmail.com</span>
              </a>
              <a
                href="tel:+33651872435"
                className="flex items-center gap-2.5 text-slate-400 hover:text-emerald-400 transition-colors"
              >
                <i className="ri-phone-line text-emerald-500 text-base flex-shrink-0"></i>
                <span>06 51 87 24 35</span>
              </a>
              <div className="pt-3">
                <Link
                  to="/demande-devis"
                  className="inline-flex items-center gap-2 bg-gradient-to-r from-emerald-500 to-teal-500 text-white px-5 py-2.5 rounded-full text-xs font-bold hover:shadow-lg hover:shadow-emerald-500/30 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-file-text-line"></i>
                  Devis Gratuit
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Barre inférieure */}
        <div className="border-t border-slate-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-slate-500 text-xs">
          <p>&copy; 2026 UzunDigital. Tous droits réservés. — SIRET : 998 939 037 00011</p>
          <div className="flex items-center gap-4">
            <Link to="/mentions-legales" className="hover:text-emerald-400 transition-colors">
              Mentions légales
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
